import React from 'react';

const ActivitiesCompletePage = React.lazy(() => import('../../../pages/ActivitiesCompletePage/ActivitiesCompletePage'));

//This route is defined for task completion through email and can't be reached from the normal application.
export default {
  group: '',
  to: '/activities_completed',
  route: '/activities_completed',
  component: ActivitiesCompletePage,
  appearsInNavBar: false,
  hasNavBar: false,
};
